import { render, staticRenderFns } from "./StepAdminRootView.vue?vue&type=template&id=10ddf876"
import script from "./StepAdminRootView.vue?vue&type=script&lang=js"
export * from "./StepAdminRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports